import { render, staticRenderFns } from "./OpeningHoursAndClosedDays.vue?vue&type=template&id=77f22503&scoped=true&"
import script from "./OpeningHoursAndClosedDays.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursAndClosedDays.vue?vue&type=script&lang=js&"
import style0 from "./OpeningHoursAndClosedDays.vue?vue&type=style&index=0&id=77f22503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f22503",
  null
  
)

export default component.exports